import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AnimationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"animation"}/>
}
